import { getMessaging, getToken, isSupported, onMessage } from 'firebase/messaging'
import { app } from '@/config/firebase'
import notificationsService from './notificationsService'
import packageJson from '../../package.json'

const VAPID_KEY = process.env.VUE_APP_FIREBASE_VAPID_KEY

/**
 * Demande la permission de notifications et retourne true si accordée
 * @returns {Promise<boolean>}
 */
export async function requestNotificationPermission() {
  if (!('Notification' in window)) {
    console.warn('Ce navigateur ne supporte pas les notifications')
    return false
  }

  if (Notification.permission === 'granted') {
    return true
  }

  if (Notification.permission === 'denied') {
    console.warn('Permissions de notifications refusées')
    return false
  }

  const permission = await Notification.requestPermission()
  return permission === 'granted'
}

/**
 * Récupère le token FCM pour les push notifications
 * @returns {Promise<string|null>}
 */
export async function getFCMToken() {
  console.log('getFCMToken()')
  console.log('VAPID_KEY:', VAPID_KEY)
  try {
    const supported = await isSupported()
    if (!supported) {
      console.warn('Firebase Messaging non supporté dans ce navigateur')
      return null
    }

    if (!VAPID_KEY) {
      console.warn('VUE_APP_FIREBASE_VAPID_KEY manquant dans .env')
      return null
    }

    const messaging = getMessaging(app)

    const token = await getToken(messaging, {
      vapidKey: VAPID_KEY
    })

    return token
  } catch (error) {
    console.error('Erreur lors de la récupération du token FCM:', error)
    return null
  }
}

/**
 * Demande les permissions, récupère le token FCM et l'enregistre auprès du backend
 * @param {string} [deviceId] - UUID du device (optionnel)
 * @returns {Promise<boolean>}
 */
export async function registerFCMToken(deviceId = null) {
  console.clear()
  console.log('MOR()')
  const hasPermission = await requestNotificationPermission()
  if (!hasPermission) return false


  const token = await getFCMToken()
  if (!token) return false

  try {
    const deviceType = /Android/i.test(navigator.userAgent)
      ? 'android'
      : /iPhone|iPad|iPod/i.test(navigator.userAgent)
        ? 'ios'
        : 'web'

        console.clear()
        console.log('token:', token)
        console.log('deviceType:', deviceType)
        console.log('deviceId:', deviceId)
        console.log('app_version:', packageJson.version)

    await notificationsService.registerToken({
      token,
      device_type: deviceType,
      device_id: deviceId || crypto.randomUUID?.() || `web-${Date.now()}`,
      app_version: packageJson.version
    })

    return true
  } catch (error) {
    console.error('Erreur lors de l\'enregistrement du token FCM:', error)
    return false
  }
}

/**
 * Écoute les notifications push en premier plan (foreground)
 * @param {Function} callback - Fonction appelée avec { title, body, data } lors d'une notification
 * @returns {Function|null} - Fonction pour arrêter l'écoute, ou null si non supporté
 */
export async function onForegroundMessage(callback) {
  try {
    const supported = await isSupported()
    if (!supported) {
      console.warn('Firebase Messaging non supporté')
      return null
    }

    const messaging = getMessaging(app)

    const unsubscribe = onMessage(messaging, (payload) => {
      console.log('Notification reçue (foreground):', payload)

      const notification = {
        title: payload.notification?.title || 'Nouvelle notification',
        body: payload.notification?.body || '',
        data: payload.data || {}
      }

      callback(notification)
    })

    return unsubscribe
  } catch (error) {
    console.error('Erreur lors de l\'écoute des notifications:', error)
    return null
  }
}
